define('lq/events/actions/domainFunctionCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
	'use strict';

    function DomainFunctionCommand(eventData, eventArg) {
	    EventAction.call(this, eventData, eventArg);
	    return this;
	}

    EventAction.extend(DomainFunctionCommand, EventAction);

    DomainFunctionCommand.typeName = 'DomainFunctionCommand';

	DomainFunctionCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

	DomainFunctionCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'DomainFunction',
            ObjectName: this.eventData.command
        };
    };

	return DomainFunctionCommand;
});
